import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import localePtBr from '@angular/common/locales/pt';
import { Injectable } from "@angular/core";
import { Observable, of } from 'rxjs';
import { UserAuthIamService } from 'src/app/features/proof-of-life/services/user-auth-iam/user-auth-iam.service';
import User from 'src/app/features/proof-of-life/services/user-auth/User';
import { MockTest } from 'src/app/utils/mock-test-analitico';
import { environment } from 'src/environments/environment';


registerLocaleData(localePtBr);

@Injectable({
  providedIn: 'root'
})
export class RelatorioAnaliticoService {
  public documentoCliente: string;
  public fullName: string;
  public listaServicoFalha: Array<string>;
  private userData = new User({});

  constructor(
    public http: HttpClient,
    private iamService: UserAuthIamService
  ) {
    this.verificarUsuarioLogado();
  }

  public verificarUsuarioLogado() {

    if (sessionStorage.getItem("iam") !== null) {
      this.userData = JSON.parse(sessionStorage.getItem("iam"));
      this.documentoCliente = this.userData.document;
      this.fullName = this.userData.fullName;
    }else{
      this.iamService.accountData().subscribe(
        data => {
          this.userData = data;
          this.documentoCliente = this.userData.document;
          this.fullName = this.userData.fullName;
        },
        () => {
          console.log('UserData error');
        }
      );
    }
  }

  public consultarInformacoesRelatorio(pedido: string): Observable<any> {
    if (environment.name == 'local') {
      return of(MockTest.criarMockconsultarInformacoesRelatorio())
      }

    if (environment.name == 'develop') {
        return this.http.get(environment.urlAnalitico + '/lgpd/analitico/pedido/v1/dataorder/' + pedido);
    }
    return this.http.get(environment.urlAnalitico + '/lgpd/analitico/v1/dataorder/' + pedido);
  }

  public retrievePedido(): Observable<any> {

    if (environment.name == 'local') {
    return of(MockTest.criarMockPedido('3123', 'finalizado'))
    }
    if (environment.name == 'develop') {
        return this.http.get(environment.urlAnalitico + '/lgpd/analitico/pedido/v1/pedidos');
    }
    return this.http.get(environment.urlAnalitico + '/lgpd/analitico/v1/pedidos');
  }

  public baixarPdf(obj: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/pdf' });
    return this.http.post(environment.urlHistoricoPedidoDownload,
      obj,
      {
        headers,
        responseType: 'blob'
      }
    );
  }

}
